import React, { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { authApi } from "../../lib/authApi";
import { setMemberSession } from "../../hooks/useMemberAuth";
import { AuthShell, PrimaryBtn, Notice, SmallLink } from "../../components/auth/AuthShell";

const VerifyEmailPage = () => {
  const [params] = useSearchParams();
  const token = params.get("token");
  const [state, setState] = useState("checking");  // checking | success | error
  const [msg, setMsg] = useState(null);

  useEffect(() => {
    if (!token) { setState("error"); setMsg("Missing token."); return; }
    let cancel = false;
    (async () => {
      try {
        const { data } = await authApi.verifyEmail(token);
        if (cancel) return;
        if (data.session_token) await setMemberSession(data.session_token);
        setState("success");
      } catch (e) {
        if (cancel) return;
        setState("error");
        setMsg(e?.response?.data?.detail || "Verification failed.");
      }
    })();
    return () => { cancel = true; };
  }, [token]);

  if (state === "checking") {
    return <AuthShell title="Verifying credentials…"><Notice data-testid="verify-checking">Cross-referencing token…</Notice></AuthShell>;
  }
  if (state === "success") {
    return (
      <AuthShell title="Verified · access granted"
                 lead="Your Archive account is now active. You're signed in."
                 footer={<SmallLink to="/members" data-testid="verify-go-desk">ENTER MEMBER DESK</SmallLink>}>
        <Notice kind="success" data-testid="verify-success">Verification complete.</Notice>
        <Link to="/auth/access-granted?welcome=1" className="block">
          <PrimaryBtn type="button" data-testid="verify-go-desk-btn">ENTER THE ARCHIVE</PrimaryBtn>
        </Link>
      </AuthShell>
    );
  }
  return (
    <AuthShell title="Verification failed" lead="The link may be expired or already used.">
      <Notice kind="error" data-testid="verify-error">{msg}</Notice>
      <SmallLink to="/auth/login" data-testid="verify-back-login">BACK TO SIGN IN</SmallLink>
    </AuthShell>
  );
};

export default VerifyEmailPage;
